import React from 'react';
import { ServiceStatus } from '../../../../../domain/entities/ServiceEntity';
import './StepperComponent.scss';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CelebrationIcon from '@mui/icons-material/Celebration';

interface StepperComponentProps {
    currentStatus: ServiceStatus;
}

const StepperComponent: React.FC<StepperComponentProps> = ({ currentStatus }) => {
    const steps = [
        { status: ServiceStatus.WaitingForAcceptance, label: 'Esperando Valet', icon: <LocalParkingIcon /> },
        { status: ServiceStatus.DeliveriedStarted, label: 'Orden Tomada', icon: <AssignmentIcon /> },
        { status: ServiceStatus.OnWayToDeliver, label: 'En Camino', icon: <DirectionsCarIcon /> },
        { status: ServiceStatus.WaitingForPickup, label: 'Listo para Entrega', icon: <CheckCircleIcon /> },
        { status: ServiceStatus.Delivered, label: 'Entregado', icon: <CelebrationIcon /> },
    ];

    const getCurrentStepIndex = () => {
        const index = steps.findIndex(step => step.status === currentStatus);
        return index >= 0 ? index : -1;
    };

    const currentStepIndex = getCurrentStepIndex();

    // Calcular el porcentaje de progreso para la línea amarilla
    const progressPercentage = currentStepIndex >= 0 
        ? (currentStepIndex  / (steps.length - 1)) * 100 
        : 0;

    return (
        <div className="stepper-component">
            <div 
                className="stepper-container"
                style={{
                    ['--progress-width' as any]: `${progressPercentage}%`
                } as React.CSSProperties}
            >
                {steps.map((step, index) => (
                    <div 
                        key={step.status}
                        className={`stepper-step ${index <= currentStepIndex ? 'active' : ''} ${index < currentStepIndex ? 'completed' : ''}`}
                    >
                        <div className="stepper-circle">
                            <span className="stepper-icon">{step.icon}</span>
                        </div>
                        <div className="stepper-label">{step.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StepperComponent;
